import React from "react";

import { CloseRounded } from "@mui/icons-material";
import { Box, DialogContent } from "@mui/material";

import { ModalTransition } from "../ModalTransition";
import PageHeader from "../PageHeader";

import { ModalBaseType } from "../../types/common";
import { WideDialog } from "../MainModalSimple/styles";

type ModalImageProps = ModalBaseType & {
  imageUrl: string;
};

export default function ModalImage({ imageUrl, onClose }: ModalImageProps) {
  const [open, setOpen] = React.useState(true);

  const handleClose = () => {
    setOpen(false);
    setTimeout(() => {
      if (onClose) onClose();
    }, 200);
  };

  return (
    <WideDialog
      fullWidth={true}
      open={open}
      onClose={handleClose}
      TransitionComponent={ModalTransition}
    >
      <DialogContent>
        <PageHeader
          size="subtitle"
          title={""}
          rightIcon={<CloseRounded />}
          onRightAction={handleClose}
        />

        <Box>
          <img
            src={imageUrl}
            alt="Ver Imagem"
            style={{
              width: "100%",
              objectFit: "cover",
              borderRadius: 15,
            }}
          />
        </Box>
      </DialogContent>
    </WideDialog>
  );
}
